var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-form-item',{attrs:{"label":_vm.$t('scope.text_59')}},[_c('vxe-grid',{attrs:{"columns":_vm.columns,"data":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }